

import React, { useCallback, useContext } from 'react';
import { useDrop } from 'react-dnd';
import { DragContainter } from './styles';
import { useDocumentContext, COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../context/complexDocumentContext';
import { useArtboardContext, CONTEXT_KEYS } from '../../context/complexArtboardContext';
import { AppStoreContext } from '../../context/appStoreContext';
import { message } from 'antd';
import { REUSABLE_FLOW, TOC } from '../../utils/complexDocumentConstants';
import { staticTocFlow } from '../../utils/constants/staticTocFlow';
import { COMPLEX_PAGE_OPTIONS } from './translationValues';
import { reloadTableOfContents } from '../../utils/helper';

const ComplexNewPage = (props) => {
    const { uuid, flowNumber, maxWidth, CurrentDesign, t } = props;
    const customSelector = useCallback(() => null, []);
    const [, methods] = useDocumentContext(customSelector, `DesignPage-${uuid}`);

    const { checkUserAccess } = useContext(AppStoreContext);

    const confimationModalSelector = useCallback(store => store[CONTEXT_KEYS.CLONE_FLOW], []);
    const [, updateArtboard] = useArtboardContext(confimationModalSelector, `ConfirmationPageModal`);
 
    const onDrop = useCallback((item, monitor) => {
        if(item.type === TOC){
            const flowUUIDS = methods.get()[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS];
            for (let i in flowUUIDS) {
              const flowName = methods.get()[flowUUIDS[i]]?.flowName;
              if (flowName === 'TABLE OF CONTENTS') {
                message.warning(t(COMPLEX_PAGE_OPTIONS.TOC_ALREADY_EXISTS.key, COMPLEX_PAGE_OPTIONS.TOC_ALREADY_EXISTS.value));
                return;
              }
            }
            methods.set({ [COMPLEX_DOCUMENT_CONTEXT_KEYS.AUTOSAVE_CALLBACK]: () => reloadTableOfContents(methods)});
            methods.setNewFlow(staticTocFlow, uuid, flowNumber, false, CurrentDesign);
        }else{
            const flowItem = item.element.elementDetails;
            methods.set({
                [COMPLEX_DOCUMENT_CONTEXT_KEYS.CLONE_FLOW]: { flowId: flowItem.flowId, uuid: uuid, flowNumber: flowNumber },
                [COMPLEX_DOCUMENT_CONTEXT_KEYS.NEW_LANGUAGE_CODE]: item?.element?.language,
                [COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_DRAG_ACTION]: true,
            });
            if (checkUserAccess('master')) {
                updateArtboard({ [CONTEXT_KEYS.REUSABLE_TYPE]: REUSABLE_FLOW });
            } else {
                updateArtboard({ [CONTEXT_KEYS.CONFIMATION_PAGE_MODAL]: true, [CONTEXT_KEYS.REUSABLE_TYPE]: REUSABLE_FLOW });
            }
        }
    }, []);

    const [isOver, topDrop] = useDrop({
        canDrop: () => true,
        accept: [REUSABLE_FLOW, TOC],
        collect: monitor => !!monitor.isOver({ shallow: true }),
        drop: (item, monitor) => {
            onDrop(item, monitor);
        },
    });

    return (
        <>
            <DragContainter maxWidth={maxWidth}>
                <div className={`bottomDrop ${isOver ? 'visible' : ''}`} ref={topDrop}> </div>
            </DragContainter>

        </>
    )
};

export default ComplexNewPage;